import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CSmartTable,
} from '@coreui/react-pro'
import Add from '@mui/icons-material/Add'
import MoreVert from '@mui/icons-material/MoreVert'
import { Chip, IconButton } from '@mui/material'
import debounce from 'lodash/debounce'
import { useCallback, useContext, useEffect, useState } from 'react'
import useInfiniteScroll from 'react-infinite-scroll-hook'
import { useNavigate } from 'react-router-dom'
import {
  CustomInput,
  CustomSelect,
  ImageViewComponent,
  OverflowingArrayChips,
  SentryRefHandler,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import { checkAndGetTargetValue } from 'src/consumer/helpers/utilFunctions'
import { mediaURL } from 'src/consumer/services'
import { MentorProfileContext } from '../../context/MentorProfileContext'
import { MentorSetupContext } from '../../context/MentorSetupContext'
import { getMPDataWithParams } from '../../services'
import { AddPricingFab } from '../MentorEventsPage/MentorEventsPageStyles'
import MentorHeader from '../MentorHeader'
import {
  ProfileTabButton,
  ProfileTabButtonContainer,
  ProfileTabContainer,
} from '../MentorProfilePage/MentorProfilePageStyles'
import { ActivityPlanListingContainer } from './components/styledComponents'
import './customPlansStyles.css'

const API_URL_FOR_CUSTOM_PLANS = {
  'open-to-all': '/api/secure/entity/activity-plan/list/summary/open-to-all',
  mentor: '/api/secure/teacher/activity-plans/summary',
}

const ACTIVITY_PLAN_TYPES = [
  { id: 'open-to-all', value: 'Open to All' },
  { id: 'mentor', value: 'My Plans' },
]

const columns = [
  {
    key: 'coverIcon',
    label: '',
    _style: { minWidth: '100px' },
    filter: false,
    sorter: false,
  },
  { key: 'title', label: 'Title' },
  // {
  //   key: 'subscriptionType',
  //   label: 'Subscription Type',
  //   _style: { minWidth: '100px' },
  //   filter: false,
  //   sorter: false,
  // },
  // {
  //   key: 'pricePlan',
  //   label: 'Subscription Plan',
  //   _style: { minWidth: '150px' },
  //   filter: false,
  //   sorter: false,
  // },
  // {
  //   key: 'visibility',
  //   label: 'Visibility',
  //   _style: { minWidth: '100px' },
  //   filter: false,
  //   sorter: false,
  // },
  {
    key: 'domainIds',
    label: 'Domains',
    _style: { minWidth: '150px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'status',
    label: 'Status',
    _style: { minWidth: '100px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'totalDays',
    label: 'Total Days',
    _style: { minWidth: '100px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'numberOfPhases',
    label: 'Number of Phases',
    _style: { minWidth: '100px' },
    filter: false,
    sorter: false,
  },
  {
    key: 'actions',
    label: 'Actions',
    _style: { minWidth: '80px' },
    filter: false,
    sorter: false,
  },
]

export default function CustomPlans() {
  const { allTags } = useContext(MentorSetupContext)
  const { mentorProfileData, allLegalPolicies } = useContext(MentorProfileContext)
  const navigate = useNavigate()
  const [customPlans, setCustomPlans] = useState()
  const [loading, setLoading] = useState(false)
  const unAcceptedAgreements = allLegalPolicies?.filter((agreement) => !agreement?.singed)?.length
  const scopedColumns = {
    subscriptionType: (item) => {
      // const foundSubscriptionType = dropDownData?.allPlanLevels?.find(
      //   (planLevel) => planLevel?.id === item?.subscriptionType,
      // )
      return <td>{item?.subscriptionType || 'None'}</td>
    },
    domainIds: (item) => {
      const foundDomainIds = item?.domainIds?.map((domainId) => {
        return allTags?.find((ddnDomain) => ddnDomain?.id === domainId)
      })
      return (
        <td>
          <OverflowingArrayChips
            allItems={foundDomainIds}
            getTitle={(ddnDomain) => ddnDomain?.title || ddnDomain?.name || ddnDomain?.id}
            maxChips={3}
          />
        </td>
      )
    },
    numberOfPhases: (item) => {
      return <td>{!!item?.phaseIds?.length ? item?.phaseIds?.length : 'None'}</td>
    },
    numberOfPlannedActivities: (item) => {
      return (
        <td>{!!item?.plannedActivityIds?.length ? item?.plannedActivityIds?.length : 'None'}</td>
      )
    },
    status: (item) => {
      return (
        <td>
          {item?.status === 'draft' ? (
            <Chip label="Draft" color="warning" />
          ) : (
            <Chip label="Published" color="success" />
          )}
        </td>
      )
    },
    actions: (item) => {
      return (
        <td className="py-2 table-actions">
          <div onClick={(e) => e.stopPropagation()}>
            <CDropdown variant="dropdown">
              <CDropdownToggle custom={true}>
                <IconButton>
                  <MoreVert />
                </IconButton>
              </CDropdownToggle>
              <CDropdownMenu>
                <CDropdownItem
                  onClick={() => {
                    const { ...cleanedItem } = item
                    handleViewClick(cleanedItem)
                  }}
                >
                  View
                </CDropdownItem>
                <CDropdownItem
                  onClick={() => {
                    const { ...cleanedItem } = item
                    handleEditClick(cleanedItem)
                  }}
                >
                  Edit
                </CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </div>
        </td>
      )
    },
    coverIcon: (item) => {
      return (
        <td>
          <ImageViewComponent
            imageId={item.coverIcon}
            src={`${mediaURL}${item.coverIcon}`}
            alt="cover_image"
            variant="rounded"
            sx={{
              width: '50px',
              height: '50px',
            }}
          />
        </td>
      )
    },
  }
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(50)
  const [filters, setFilters] = useState({
    domainIds: [],
    planTypes: 'mentor',
  })
  const [searchInput, setSearchInput] = useState('')
  const [hasMore, setHasMore] = useState(true)

  async function customPlanGetter(
    pageNumber = page,
    size = pageSize,
    tableFilters,
    search,
    addToList = false,
  ) {
    const apiUrlToUse = '/api/secure/teacher/activity-plans/summary'

    const response = await getMPDataWithParams(apiUrlToUse, {
      page: pageNumber,
      size: size,
      domainIds: tableFilters?.domainIds?.join(','),
      search: search,
      mentorId: tableFilters?.planTypes !== 'open-to-all' ? mentorProfileData.id : null,
    })

    setHasMore(response.status === 200 && response.data.length !== 0)
    if (response.status === 200) {
      const allActivityPlans = response.data

      setCustomPlans((prev) => {
        const apToReturn = allActivityPlans.map((item) => {
          let itemToReturn = item
          columns.forEach((col) => {
            if (itemToReturn?.[col.key] === undefined) {
              itemToReturn = { ...itemToReturn, [col.key]: null }
            }
          })
          return itemToReturn
        })

        return addToList ? [...prev, ...apToReturn] : apToReturn
      })
    }
  }

  async function Setup() {
    setLoading(true)
    await Promise.all([customPlanGetter()])
    setLoading(false)
  }

  async function addCustomPlan() {
    navigate('new-plan?mode=Add')
  }

  function handleChangeFilters(e) {
    setFilters((prevFilters) => {
      return {
        ...prevFilters,
        [e.target.id]: checkAndGetTargetValue(e),
      }
    })
  }
  async function searchFunction(e) {
    setLoading(true)
    setSearchInput(e.target.value)
  }
  async function handleFireApiOnUpdatedFilters(page, pageSize, filters, searchInput) {
    setLoading(true)
    await customPlanGetter(1, pageSize, filters, searchInput)
    setPage(1)
    setLoading(false)
  }

  const debouncedSearch = useCallback(
    debounce(async (page, pageSize, filters, searchInput) => {
      await customPlanGetter(1, pageSize, filters, searchInput)
      setPage(1)
      setLoading(false)
    }, 500),
    [setPage],
  )

  function handleViewClick(item) {
    navigate(`${item?.id}?mode=View`)
  }

  function handleEditClick(item) {
    navigate(`${item?.id}?mode=Edit`)
  }

  async function getNextPage() {
    setLoading(true)
    const nextPage = page + 1
    await customPlanGetter(nextPage, pageSize, filters, searchInput, true)
    setPage(nextPage)
    setLoading(false)
  }

  const [sentryRef] = useInfiniteScroll({
    loading: loading,
    hasNextPage: hasMore,
    onLoadMore: getNextPage,
    rootMargin: '0px 0px 40px 0px',
  })

  useEffect(() => {
    debouncedSearch(page, pageSize, filters, searchInput)
  }, [searchInput])
  useEffect(() => {
    handleFireApiOnUpdatedFilters(page, pageSize, filters, searchInput)
  }, [filters])

  useEffect(() => {
    Setup()
  }, [])
  return (
    <>
      <MentorHeader heading="My Homework Plans" agreements={unAcceptedAgreements} />
      <ActivityPlanListingContainer>
        <div>
          <ProfileTabButtonContainer style={{ paddingBottom: '28px' }}>
            <ProfileTabContainer>
              {ACTIVITY_PLAN_TYPES?.map((apType) => (
                <ProfileTabButton
                  selected={filters.planTypes === apType.id}
                  onClick={() =>
                    handleChangeFilters({ target: { id: 'planTypes', value: apType.id } })
                  }
                  key={apType.id}
                >
                  {apType.value}
                </ProfileTabButton>
              ))}
            </ProfileTabContainer>
          </ProfileTabButtonContainer>
        </div>
        <div className="d-flex justify-content-between align-items-center gap-2 pb-3">
          <div className="d-flex w-100 gap-2 flex-wrap">
            <div className="w-100">
              <CustomInput
                value={filters.search}
                onChange={searchFunction}
                label="Search"
                placeholder="Search Here..."
              />
            </div>
            <div style={{ maxWidth: '300px', width: '100%' }}>
              <CustomSelect
                isMulti
                id="domainIds"
                value={filters?.domainIds}
                options={allTags?.sort((a, b) => a?.title?.localeCompare(b?.title))}
                getOptionValue={(option) => option.id}
                getOptionLabel={(option) => option.name || option.title}
                onChangeEvent={handleChangeFilters}
                label="Domains"
                selectType={selectTypes.string}
              />
            </div>
          </div>
        </div>
        <AddPricingFab
          sx={{ position: 'fixed', bottom: '30px', right: '30px' }}
          onClick={addCustomPlan}
        >
          <Add />
        </AddPricingFab>
        <CSmartTable
          columns={columns?.filter((col) =>
            filters.planTypes === 'open-to-all' ? col.key !== 'actions' : true,
          )}
          items={customPlans?.map((item) => ({
            ...item,
            _props: { style: { verticalAlign: 'middle' } },
          }))}
          handleFormViewClick={handleViewClick}
          loading={loading}
          scopedColumns={scopedColumns}
          paginationProps={{ align: 'center' }}
          tableProps={{
            hover: true,
            striped: true,
            responsive: true,
          }}
          tableBodyProps={{
            className: 'custom-plan-table',
          }}
        />
        <SentryRefHandler sentryRef={sentryRef} loading={loading} hasNextPage={hasMore} />
      </ActivityPlanListingContainer>
    </>
  )
}
